import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import axios, { AxiosResponse } from 'axios';
import { Commission } from 'src/models/commission.model';

type InitialState = {
  loading: boolean;
  success: boolean;
  failure: boolean;
  commissions: Commission[];
};

const INITIAL_STATE: InitialState = {
  loading: false,
  success: false,
  failure: false,
  commissions: [] as Commission[],
};

export const searchUserCommissions = createAsyncThunk(
  'timesheet/user-commissions/post',
  async (data: { userId: number; roleId: number }, { rejectWithValue }) => {
    try {
      const response: AxiosResponse<Commission[]> = await axios.post(`/api/timesheet/user-commissions`, data);

      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

const searchCommissionsSlice = createSlice({
  name: 'searchCommissions',
  initialState: INITIAL_STATE,
  reducers: {
    resetSearchUserCommission: () => {
      return INITIAL_STATE;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(searchUserCommissions.pending, (state): InitialState => {
        return {
          ...state,
          loading: true,
          success: false,
          failure: false,
        };
      })
      .addCase(searchUserCommissions.fulfilled, (state, action: PayloadAction<Commission[]>): InitialState => {
        return {
          ...state,
          loading: false,
          success: true,
          failure: false,
          commissions: action.payload,
        };
      })
      .addCase(searchUserCommissions.rejected, (state): InitialState => {
        return {
          ...state,
          loading: false,
          success: false,
          failure: true,
        };
      });
  },
});

export const { resetSearchUserCommission } = searchCommissionsSlice.actions;

export default searchCommissionsSlice.reducer;
